Ext.define('SA.view.pvt.Fill', {
    alias: 'widget.pvt-fill',
    extend: 'Ext.Component',

    cls: 'sa-pvt-fill'
});